const CommonProps = {
    margin: {
        top: 20,
        right: 50,
        bottom: 130,
        left: 120
    },
    padding: .15,
    labelTextColor: 'inherit:darker(1.4)',
    labelSkipWidth: 90,
    labelSkipHeight: 20,
}

export {CommonProps}